import { z } from "zod";
import { ZProjectNo } from "./foundationSchema";
export const ZViewIdInput = z.object({
    projectNo: ZProjectNo,
    viewId: z.string().regex(/^[0-9a-fA-F]{24}$/, "Invalid view ID"),
});
